import React, {useState, Fragment} from "react";
import PropTypes from "prop-types";
import TabMain from "./TabMain";
import CardsTextAvatarCTA from "./CardsTextAvatarCTA";
import GridLayout from "./Grid";
import GridLayout2 from "./Grid_2";
import GridLayout3 from "./Grid_3";
import LoginTrialOrMemberDialog from "../../dialog/membership/LoginTrialOrMemberDialog";
import {
    Table,
    TilesBookings,
    TextBlock,
    ImageLegend,
    ImageBlock,
    FactsFigures,
    Testimonials,
    ImageHero,
    PictureGallery,
    ColumnTiles,
    BackgroundImageTextCta,
    IconTitleTextCTA,
    TitleTextCTA,
    IconTitleText,
    ColumnCards,
    ComparisonCards,
    Faq,
    FaqBox,
    TextGridImage,
    Tiles1,
    TilesImages,
    TilesAmenities,
    NumberedtitleTextImage,
    ColumnsFramedBox,
    ContactUs,
    Banner,
    Tiles3,
    TestimonialsStaff,
    NumberedSteps,
    HowManyShares,
    TitleListCta,
    TitleHighlightTextCTA,
    MarkDownText,
    PdfDownloads,
    EmbedMap,
    StepsImageTextCta,
    YoutubePlayer,
    ImageWithExpandable
} from "@hapinest/theme";
import {getTabMainItems} from "../../../selectors/tabMain";
import {getCardsTextAvatarCTAItems} from "../../../selectors/cardsTextAvatarCTA";
import {getFaqItems} from "../../../selectors/faq";
import {getTestimonialsItems} from "../../../selectors/testimonials";
import {getFactsFigures} from "../../../selectors/factsFigures";
import {getStepsImageTextCtaItems} from "../../../selectors/stepsImageTextCtaSelector";
import {getIconTitleTextCtaItems} from "../../../selectors/iconTitleTextCTA";
import {getColumnCardsItems} from "../../../selectors/columnCards";
import {getComparisonCardsItems} from "../../../selectors/comparisonCards";
import {getTitleTextCtaItems} from "../../../selectors/titleTextCTA";
import {getImageLegendItems} from "../../../selectors/imageLegend";
import {getTrialCardSlider} from "../../../selectors/getTrialCardSlider";
import {getTextBlock} from "../../../selectors/getTextBlock";
import {getTableItems} from "../../../selectors/table";
import {getGridItems} from "../../../selectors/grid";
import {getBackgroundTextCtaItems} from "../../../selectors/backgroundTextCta";
import {getColumnTilesItems} from "../../../selectors/columnTiles";
import {getTiles1Items} from "../../../selectors/tiles1";
import {getTextGridImageItems} from "../../../selectors/textGridImage";
import {getTilesImages} from "../../../selectors/tilesImages";
import {getColumnsFramedBoxItems} from "../../../selectors/columnsFramedBox";
import {getTilesAmenities} from "../../../selectors/tilesAmenities";
import {getTiles3Items} from "../../../selectors/tiles3";
import {getOurTipsItems} from "../../../selectors/ourTips";
import {getNumberedItems} from "../../../selectors/numberedSteps";
import {getNumberedtitleTextImageData} from "../../../selectors/numberedTitleTextImageSelector";
import {getInvestmentItems} from "../../../selectors/investment";
import {getHowManySharesItems} from "../../../selectors/howManyShares";
import {getContactUsData} from "../../../selectors/contactUsSelector";
import {getTitleListCtaItems} from "../../../selectors/titleListCta";
import {getTitleHighlightTextCtaItems} from "../../../selectors/titleHighlightTextCTA";
import {getPdfDownloadsItems} from "../../../selectors/pdfDownloads";
import {getImageWithExpandableData} from "../../../selectors/getImageWithExpandableData";
import withRoles from "../../hoc/RoleCheckerHOC";
import {withMap} from "../../hoc/MapHOC";
import {accessControlSelector} from "../../../selectors/accessControlSelector";
import {getBannerData} from "../../../selectors/bannerSelector";
import {getVideoData} from "../../../selectors/video";
import {useI18N, useLocalizedUrl, useLocation} from "../../../common/common";
import InvestmentView from "./InvestmentView";
import {getMapProps} from "../../../selectors/embedMapSelector";
import {GOOGLE_MAPS_EMBED_BASE_URL, GOOGLE_MAPS_API_KEY} from "../../../common/api/apiConstants";
import CallUsDialog from "../../dialog/callus/CallUsDialog";
import AnchorLinker from "./AnchorLinker";
import PartnerOfferings from "./PartnerOfferings";
import {getPartnerOfferingsData} from "../../../selectors/getPartnerOfferingsData";
import OffersSlider from "./OffersSlider";
import HomeFiltersSection from "./HomeFiltersSection";
import { getOfferSliderData } from "../../../selectors/getOfferSliderData";

const HtmlComponentWrapper = ({htmlComponents, pageSlug}) => {
    const {i18n} = useI18N();
    const {getComposePagePath} = useLocation();
    const {getLocalizedUrl} = useLocalizedUrl();
    const [currentComponentSysId, setCurrentComponentSysId] = useState();
    const [isLoginTrialOrMemberDialogOpen, setLoginTrialOrMemberDialogOpen] = useState(false);
    const [callUsDialogOpen, setCallUsDialogOpen] = useState(false);

    const handleButtonClick = (buttonId, componentSysId) => {
        setCurrentComponentSysId(componentSysId);
        switch (buttonId) {
            case "register-trial-dialog":
                setLoginTrialOrMemberDialogOpen(true);
                break;
            case "contact-callus-button":
                setCallUsDialogOpen(true);
                break;
            default:
                return undefined;
        }
    };

    const getComposePageUrl = (slug) => {
        return getLocalizedUrl(getComposePagePath(slug));
    };

    return htmlComponents?.map(comp => {

        let currentComponent = undefined;

        switch (comp?.fields?.type) {
            case "embed_map": {
                currentComponent = (
                    withMap(EmbedMap)({...getMapProps(comp, `${GOOGLE_MAPS_EMBED_BASE_URL}?key=${GOOGLE_MAPS_API_KEY}`)})
                );
                break;
            }
            case "picture_gallery": {
                currentComponent = (
                    <PictureGallery
                        blogStyle
                        images={comp?.fields?.elements[0]?.fields?.pictures?.map(pic => pic?.fields)}
                    />
                );
                break;
            }
            case "topbanner":
                currentComponent = (
                    <ImageHero
                        title={comp?.fields?.title}
                        subtitle={comp?.fields?.subtitle}
                        imageUrl={comp?.fields?.image?.fields?.file?.url}
                    />
                );
                break;
            case "icon_title_text":
                currentComponent = (
                    <IconTitleText
                        bgColor={comp?.fields?.backgroundColour}
                        imageTitle={comp?.fields?.elements[0]?.fields?.image?.fields?.title}
                        imageUrl={comp?.fields?.elements[0]?.fields?.image?.fields?.file?.url}
                        title={comp?.fields?.elements[0]?.fields?.title}
                        subtitle={comp?.fields?.elements[0]?.fields?.subtitle}
                        description={comp?.fields?.elements[0]?.fields?.description}
                    />
                );
                break;
            case "icon_title_text_cta":
                currentComponent = (
                    <IconTitleTextCTA
                        {...getIconTitleTextCtaItems(comp)}
                    />
                );
                break;
            case "comparison_cards":
                currentComponent = (
                    <Fragment>
                        <ComparisonCards
                            {...getComparisonCardsItems(comp, getComposePageUrl)}
                            onButtonClick={(id) => handleButtonClick(id, comp?.sys?.id)}
                        />
                        <LoginTrialOrMemberDialog
                            isOpen={isLoginTrialOrMemberDialogOpen && currentComponentSysId === comp?.sys?.id}
                            onClose={() => setLoginTrialOrMemberDialogOpen(false)}
                        />
                    </Fragment>
                );
                break;
            case "column_cards":
                currentComponent = (
                    <Fragment>
                        <ColumnCards
                            onLinkClick={(id) => handleButtonClick(id, comp?.sys?.id)}
                            {...getColumnCardsItems(comp, getComposePageUrl)}
                        />
                        <CallUsDialog
                            isOpen={callUsDialogOpen && currentComponentSysId === comp?.sys?.id}
                            onClose={() => setCallUsDialogOpen(false)}
                        />
                    </Fragment>
                );
                break;
            case "title_text_cta":
                currentComponent = (
                    withRoles(TitleTextCTA, accessControlSelector(comp)?.rolesString)(getTitleTextCtaItems(comp, getComposePageUrl))
                );
                break;
            case "image":
                currentComponent = (
                    <ImageBlock
                        imageTitle={comp?.fields?.image?.fields?.title}
                        imageUrl={comp?.fields?.image?.fields?.file?.url}
                        imageDescription={comp?.fields?.image?.fields?.description}
                    />
                );
                break;
            case "image_legend":
                currentComponent = (
                    <ImageLegend
                        {...getImageLegendItems(comp)}
                    />
                );
                break;
            case "table":
                currentComponent = (
                    <Table
                        {...getTableItems(comp)}
                    />
                );
                break;
            case "steps_imagetext_cta":
                currentComponent = (
                    <StepsImageTextCta
                        {...getStepsImageTextCtaItems(comp)}
                    />
                );
                break;
            case "tab_main":
                currentComponent = (
                    <TabMain
                        {...getTabMainItems(comp)}
                    />
                );
                break;
            case "cards_text_avatar_cta":
                currentComponent = (
                    <CardsTextAvatarCTA
                        {...getCardsTextAvatarCTAItems(comp)}
                    />
                );
                break;
            case "grid":
                currentComponent = (
                    <GridLayout
                        {...getGridItems(comp)}
                    />
                );
                break;
            case "grid_2":
                currentComponent = (
                    <GridLayout2
                        {...getGridItems(comp)}
                    />
                );
                break;
            case "grid_3":
                currentComponent = (
                    <GridLayout3
                        {...getGridItems(comp)}
                    />
                );
                break;
            case "numberedtitle_text_image":
                currentComponent = (
                    <NumberedtitleTextImage
                        {...getNumberedtitleTextImageData(comp)}
                    />
                );
                break;
            case "faq":
                currentComponent = (
                    <Faq
                        {...getFaqItems(comp)}
                    />
                );
                break;
            case "faq_box":
                currentComponent = (
                    <FaqBox
                        {...getFaqItems(comp)}
                    />
                );
                break;
            case "columns_framed_box":
                currentComponent = (
                    <ColumnsFramedBox
                        {...getColumnsFramedBoxItems(comp)}
                    />
                );
                break;
            case "testimonials_members":
                currentComponent = (
                    <Testimonials
                        blogStyle
                        title={comp?.fields?.title}
                        bgColor={comp?.fields?.backgroundColour}
                        testimonials={getTestimonialsItems(comp?.fields?.elements)}
                    />
                );
                break;
            case "facts_figures":
                currentComponent = (
                    <FactsFigures
                        {...getFactsFigures(comp)}
                    />
                );
                break;
            case "tiles_bookings":
                currentComponent = (
                    <TilesBookings
                        {...getTrialCardSlider(comp)}
                    />
                );
                break;
            case "tiles_amenities":
                currentComponent = (
                    <TilesAmenities
                        {...getTilesAmenities(comp)}
                    />
                );
                break;
            case "text_block":
                currentComponent = (
                    <TextBlock
                        {...getTextBlock(comp)}
                    />
                );
                break;
            case "background_image_title_cta":
                currentComponent = (
                    <Fragment>
                        <BackgroundImageTextCta
                            {...getBackgroundTextCtaItems(comp, getComposePageUrl)}
                            onButtonClick={(id) => handleButtonClick(id, comp?.sys?.id)}
                        />
                        <LoginTrialOrMemberDialog
                            isOpen={isLoginTrialOrMemberDialogOpen && currentComponentSysId === comp?.sys?.id}
                            onClose={() => setLoginTrialOrMemberDialogOpen(false)}
                        />
                    </Fragment>
                );
                break;
            case "tiles_1":
                currentComponent = (
                    <Tiles1
                        {...getTiles1Items(comp)}
                    />
                );
                break;
            case "tiles_2":
                currentComponent = (
                    <Fragment>
                        <ColumnTiles
                            onButtonClick={(id) => handleButtonClick(id, comp?.sys?.id)}
                            {...getColumnTilesItems(comp)}
                        />
                        <LoginTrialOrMemberDialog
                            isOpen={isLoginTrialOrMemberDialogOpen && currentComponentSysId === comp?.sys?.id}
                            onClose={() => setLoginTrialOrMemberDialogOpen(false)}
                        />
                    </Fragment>

                );
                break;
            case "title_text_images":
                currentComponent = (
                    <TextGridImage
                        {...getTextGridImageItems(comp)}
                    />
                );
                break;
            case "tiles_images":
                currentComponent = (
                    <TilesImages
                        {...getTilesImages(comp)}
                    />
                );
                break;
            case "tiles_3":
                currentComponent = (
                    <Tiles3
                        {...getTiles3Items(comp)}
                    />
                );
                break;
            case "testimonials_staff":
                currentComponent = (
                    <TestimonialsStaff
                        {...getOurTipsItems(comp)}
                    />
                );
                break;
            case "numbered_steps":
                currentComponent = (
                    <NumberedSteps
                        {...getNumberedItems(comp)}
                    />
                );
                break;
            case "investment":
                currentComponent = (
                    <InvestmentView
                        {...getInvestmentItems(comp)}
                    />
                );
                break;
            case "howmanyshares":
                currentComponent = (
                    <HowManyShares
                        {...getHowManySharesItems(comp)}
                        labelShares={i18n("view.marketplace.create_offer.shares")}
                        labelShare={i18n("view.marketplace.create_offer.share")}
                    />
                );
                break;
            case "contact":
                currentComponent = (
                    <ContactUs
                        {...getContactUsData(comp)}
                    />
                );
                break;
            case "title_list_cta":
                currentComponent = (
                    <TitleListCta
                        {...getTitleListCtaItems(comp)}
                    />
                );
                break;
            case "title_highlight_text_cta":
                currentComponent = (
                    <TitleHighlightTextCTA
                        {...getTitleHighlightTextCtaItems(comp)}
                    />
                );
                break;
            case "pdf_downloads":
                currentComponent = (
                    <PdfDownloads
                        {...getPdfDownloadsItems(comp)}
                    />
                );
                break;
            case "markdown_text":
                currentComponent = (
                    <MarkDownText
                        description={comp?.fields?.elements[0]?.fields?.description}
                        bgColor={comp?.fields?.backgroundColour}
                    />
                );
                break;
            case "banner":
                currentComponent = (
                    withRoles(Banner, accessControlSelector(comp)?.rolesString)(getBannerData(comp))
                );
                break;
            case "video":
                currentComponent = (
                    <YoutubePlayer
                        {...getVideoData(comp)}
                    />
                );
                break;
            case "image_with_expandable":
                currentComponent = (
                    <ImageWithExpandable
                        {...getImageWithExpandableData(comp)}
                    />
                );
                break;
            case "partner_offerings":
                currentComponent = (
                    <PartnerOfferings
                        data={getPartnerOfferingsData(comp)}
                    />
                );
                break;
            case "offers_slider":
                currentComponent = (
                    <OffersSlider 
                        data={getOfferSliderData(comp)} 
                        slug={pageSlug}
                    />
                );
                break;
            case "filters":
                currentComponent = (
                    <HomeFiltersSection />
                );
                break;
            default:
                break;
        }
        return comp?.fields?.anchorName ? (
            <AnchorLinker
                anchorName={comp?.fields?.anchorName}
                key={comp?.sys?.id}
            >
                {currentComponent}
            </AnchorLinker>
        ) : <Fragment key={comp?.sys?.id}>{currentComponent}</Fragment>;
    });

};

HtmlComponentWrapper.propTypes = {
    htmlComponents: PropTypes.array,
    pageSlug: PropTypes.string
};

export default HtmlComponentWrapper;
